import { getWindow } from '@jira/ssr__browser-globals/src/getWindow.tsx';

/**
 * Like callWhenIdle from @jira/platform__utils-call-when-idle, but modified to add a timeout due to
 * suspected render loops meaning requestIdleCallback never runs.
 */
export const callWhenIdleWithTimeout = (
	callback: (deadline?: IdleDeadline) => void,
): (() => void) => {
	const browserWindow = getWindow();
	if (typeof browserWindow?.requestIdleCallback === 'function') {
		const callbackId = browserWindow.requestIdleCallback(
			callback,
			// In case there's a render loop on the page starving out idle callbacks
			{ timeout: 5_000 },
		);
		return () => browserWindow.cancelIdleCallback(callbackId);
	}
	// Browsers without requestIdleCallback
	const timer = setTimeout(callback, 2_000);
	return () => {
		clearTimeout(timer);
	};
};
